import axios from "../http_utils/axiosConfig";

// Constants for theme management
// These constants are also used in src/scss/colors.css
// Since CSS cannot import JavaScript constants, make sure to keep both files aligned
// when adding/removing/changing theme values

const THEME_ATTRIBUTE = "data-theme";
const VALID_THEMES = {
  GREEN: "GREEN",
  PURPLE: "PURPLE",
  BLUE: "BLUE",
};
const DEFAULT_THEME = VALID_THEMES.PURPLE;

export const initializeTheme = async () => {
  try {
    const response = await axios.get(`/tenants/color-theme`);
    const theme = response.data.success.color_theme;

    // Check if theme is valid, otherwise use default
    if (theme && Object.values(VALID_THEMES).includes(theme)) {
      document.body.setAttribute(THEME_ATTRIBUTE, theme);
    } else {
      document.body.setAttribute(THEME_ATTRIBUTE, DEFAULT_THEME);
    }
  } catch (error) {
    document.body.setAttribute(THEME_ATTRIBUTE, DEFAULT_THEME);
  }
};

export const clearTheme = () => {
  document.body.removeAttribute(THEME_ATTRIBUTE);
};
